import { render, staticRenderFns } from "./Orders.vue?vue&type=template&id=c253dd74&scoped=true&"
import script from "./Orders.vue?vue&type=script&lang=js&"
export * from "./Orders.vue?vue&type=script&lang=js&"
import style0 from "./Orders.vue?vue&type=style&index=0&id=c253dd74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c253dd74",
  null
  
)

export default component.exports